<build-section
  [disabled]="disabled"
  [title]="'cakeBuilder.greetingCardSection.title' | translate">
  <div class="font-xl clearfix">
    <ui-checkbox class="float-start"
                 [model]="isGreetingText"
                 (modelChange)="isGreetingText=$event; onChecked.emit($event)">
      <span [translate]="'common.yes'"></span> - {{cardPrice | currencyFormat: currency}}
    </ui-checkbox>
  </div>
  <div class="mt-4" *ngIf="isGreetingText">
    <div class="form-group mb-2">
      <ui-expandable-textarea
        [placeholder]="'common.textareaPlaceholder' | translate"
        [(model)]="text"
        [allowEmoji]="false"
        (modelChange)="textChanged$.next($event)">
      </ui-expandable-textarea>
    </div>
    <div class="fw-bold font-sm">
      {{ 'common.limitLetters' | translate:{length: textLength, maxLength: maxLength} }}
    </div>
  </div>
  <div class="help-text" [innerHTML]="'cakeBuilder.greetingCardSection.helpText' | translate"></div>
</build-section>
